module.exports = __webpack_public_path__ + "static/media/12UNCTAD16.c24568b6.jpg";